import { defineComponent, h } from "vue";
import BuyBox from "../../components/BuyBox/BuyBox.mjs";
import "core-js/modules/es.array.push.js";
import { UPDATE_COMPONENT_MOUNTED, INIT_PRODUCT_PAGE_MOUNT, METRICS_CLICK, OPEN_MODAL, OPEN_DISCLAIMER_MODAL, HANDLE_SIZE_CHANGE, HANDLE_COLOR_CHANGE, HANDLE_SKU_SELECT_CHANGE, HANDLE_FULFILLMENT_CHANGE, HANDLE_STORE_PICKUP_FLOW, HANDLE_QUANTITY_CHANGE, UPDATE_TEMP_COLOR, ADD_TO_CART_BUYBOX_FLOW, UPDATE_BUYBOX_VALIDATION, HANDLE_INCLUDE_MEMBERSHIP_CHANGE, HANDLE_MEMBER_INFO_CLICK, LOAD_CMS_CONTENT, HANDLE_SHIPPING_INFO_CLICK, HANDLE_OVERSIZE_INFO_CLICK, HANDLE_WISHLIST_FLOW, HANDLE_SIZE_HOVER, HANDLE_COLOR_HOVER, HANDLE_DIVIDEND_CLICK, HANDLE_NOTIFY_ME_CLICK, HANDLE_NOTIFY_ME_EMAIL_CHANGE, HANDLE_SIZE_CHART_CLICK, HANDLE_UPDATE_SHIPPING_ADDRESS, GET_USER_GEOLOCATION, SET_INLINE_SHIP_EDITOR_OPEN, SET_SHIP_GEO_ERROR, OPEN_PREORDER_MODAL } from "../../store/constants.mjs";
import "bezier-easing";
import "js-cookie";
import "core-js/modules/esnext.set.difference.v2.js";
import "core-js/modules/esnext.set.intersection.v2.js";
import "core-js/modules/esnext.set.is-disjoint-from.v2.js";
import "core-js/modules/esnext.set.is-subset-of.v2.js";
import "core-js/modules/esnext.set.is-superset-of.v2.js";
import "core-js/modules/esnext.set.symmetric-difference.v2.js";
import "core-js/modules/esnext.set.union.v2.js";
/* empty css                                              */
/* empty css                                                   */
import "@rei/cdr-tokens";
import "@rei/cedar";
/* empty css                                             */
/* empty css                                                         */
import "@rei/session";
import useProductBuyBoxStore from "../../stores/productBuyBoxStore.mjs";
import { useStore } from "../../../node_modules/vuex/dist/vuex.mjs";
const BuyBoxContainer = defineComponent({
  name: "BuyBoxContainer",
  setup() {
    var _a, _b, _c;
    const vuex = useStore();
    let buyBoxStore;
    if ((_c = (_b = (_a = vuex == null ? void 0 : vuex.getters) == null ? void 0 : _a.appPropsMap) == null ? void 0 : _b.launchToggles) == null ? void 0 : _c.usePinia) {
      buyBoxStore = useProductBuyBoxStore();
    }
    return { buyBoxStore };
  },
  mounted() {
    this.$store.commit(UPDATE_COMPONENT_MOUNTED, "BuyBoxContainer");
    this.$store.dispatch(INIT_PRODUCT_PAGE_MOUNT);
  },
  render() {
    const {
      state,
      getters,
      commit,
      dispatch
    } = this.$store;
    return h(BuyBox, {
      ...getters.buyBoxProps,
      onMetricsClick: (data) => dispatch(METRICS_CLICK, data),
      onModalOpen: (data) => dispatch(OPEN_MODAL, data),
      onOpenDisclaimerModal: () => dispatch(OPEN_DISCLAIMER_MODAL),
      onSizeUpdate: (data) => {
        var _a;
        dispatch(HANDLE_SIZE_CHANGE, data);
        (_a = this.buyBoxStore) == null ? void 0 : _a.handleSizeChange(data);
      },
      onColorUpdate: (data) => {
        var _a;
        dispatch(HANDLE_COLOR_CHANGE, data);
        (_a = this.buyBoxStore) == null ? void 0 : _a.handleColorChange(data);
      },
      onSkuSelectUpdate: (data) => dispatch(HANDLE_SKU_SELECT_CHANGE, data),
      onShipUpdate: (data) => dispatch(HANDLE_FULFILLMENT_CHANGE, data),
      onStoreFinderClick: (data) => dispatch(HANDLE_STORE_PICKUP_FLOW, data),
      onQtyUpdate: (data) => dispatch(HANDLE_QUANTITY_CHANGE, data),
      onCarouselHover: (data) => commit(UPDATE_TEMP_COLOR, data),
      onAddToCart: () => dispatch(ADD_TO_CART_BUYBOX_FLOW),
      onRegisterRef: (data) => {
        commit(UPDATE_BUYBOX_VALIDATION, {
          [data.type]: { hasError: state.buyBoxValidation[data.type].hasError, el: data.value }
        });
      },
      onIncludeMembership: (data) => dispatch(HANDLE_INCLUDE_MEMBERSHIP_CHANGE, data),
      onMemberInfoClick: () => dispatch(HANDLE_MEMBER_INFO_CLICK),
      onLoadCmsContent: (data) => dispatch(LOAD_CMS_CONTENT, data),
      onShippingInfoClick: (data) => dispatch(HANDLE_SHIPPING_INFO_CLICK, data),
      onOversizeInfoClick: (data) => dispatch(HANDLE_OVERSIZE_INFO_CLICK, data),
      onAddToWishlist: () => dispatch(HANDLE_WISHLIST_FLOW),
      onSizeHover: (data) => dispatch(HANDLE_SIZE_HOVER, data),
      onColorHover: (data) => dispatch(HANDLE_COLOR_HOVER, data),
      onDividendClick: (data) => dispatch(HANDLE_DIVIDEND_CLICK, data),
      onNotifyMe: (data) => dispatch(HANDLE_NOTIFY_ME_CLICK, data),
      onEmailUpdate: (data) => dispatch(HANDLE_NOTIFY_ME_EMAIL_CHANGE, data),
      onSizeChartClick: (data) => dispatch(HANDLE_SIZE_CHART_CLICK, data),
      onUpdateAddress: (data) => {
        dispatch(HANDLE_UPDATE_SHIPPING_ADDRESS, data);
      },
      onUpdateGeolocation: (data) => dispatch(GET_USER_GEOLOCATION, data),
      onUpdateEditorOpen: (data) => commit(SET_INLINE_SHIP_EDITOR_OPEN, data),
      onClearGeolocationError: () => commit(SET_SHIP_GEO_ERROR, false),
      onPreorderBannerClick: () => dispatch(OPEN_PREORDER_MODAL)
    });
  }
});
export {
  BuyBoxContainer as default
};
//# sourceMappingURL=BuyBoxContainer.mjs.map
